
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcSequenceStep as ObcSequenceStepElement} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';
 
 
 

 
 export const ObcSequenceStep = createComponent({
   react: React,
   tagName: 'obc-sequence-step',
   elementClass: ObcSequenceStepElement,
   events: {
     
   }
  });
 
 